var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteLabelActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11293",
    "data-name": "Path 11293",
    d: "M30.787,19.15,22,10.34l3.519-3.519.392.271c1.212.831,3.242,1.8,3.981,1.344A6.144,6.144,0,0,0,31.5,5.984a7.973,7.973,0,0,1,1.3-2.175A2.913,2.913,0,0,1,35.01,3a3.346,3.346,0,0,1,2.152.958,3.1,3.1,0,0,1,.121,4.379h0A8.014,8.014,0,0,1,35.1,9.63a6.113,6.113,0,0,0-2.452,1.615c-.4.652.577,2.821,1.379,4.038l.271.392Zm-7.171-8.81,7.171,7.165,2.025-2.025c-.663-1.05-2-3.462-1.154-4.875A6.6,6.6,0,0,1,34.6,8.557a7.16,7.16,0,0,0,1.852-1.073,1.973,1.973,0,0,0-.11-2.758,2.135,2.135,0,0,0-1.39-.577,1.731,1.731,0,0,0-1.35.5,7.327,7.327,0,0,0-1.073,1.806A6.667,6.667,0,0,1,30.481,9.4c-1.39.86-3.8-.45-4.835-1.108Z",
    transform: "translate(-9.308 -1.265)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11294",
    "data-name": "Path 11294",
    d: "M23.224,28.268l-7.3-7.3,4.65-4.65.813.813L17.553,20.97l5.671,5.665L27.055,22.8l.819.813Z",
    transform: "translate(-6.735 -6.905)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11295",
    "data-name": "Path 11295",
    d: "M25.061,31.189a.574.574,0,0,1-.4-.981l2-2a.577.577,0,1,1,.813.813l-2,2A.577.577,0,0,1,25.061,31.189Z",
    transform: "translate(-10.361 -11.851)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11296",
    "data-name": "Path 11296",
    d: "M19.577,25.884a.58.58,0,0,1-.41-.987L20.9,23.167a.577.577,0,1,1,.813.819L19.98,25.717a.577.577,0,0,1-.4.167Z",
    transform: "translate(-8.038 -9.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11297",
    "data-name": "Path 11297",
    d: "M22.667,29.37a.574.574,0,0,1-.41-.981l1.252-1.252a.577.577,0,1,1,.813.819L23.076,29.2A.577.577,0,0,1,22.667,29.37Z",
    transform: "translate(-9.345 -11.41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3775",
    "data-name": "Rectangle 3775",
    width: 1.413,
    height: 1.154,
    transform: "translate(24.838 4.895) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11298",
    "data-name": "Path 11298",
    d: "M8.651,30.643a.574.574,0,0,1-.4-.981L11.2,26.708a.577.577,0,0,1,.813.813L9.06,30.476A.577.577,0,0,1,8.651,30.643Z",
    transform: "translate(-3.418 -11.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11299",
    "data-name": "Path 11299",
    d: "M19.8,41.947a.577.577,0,0,1-.41-.987L22.4,37.955a.577.577,0,0,1,.819.813l-3.006,3.006A.577.577,0,0,1,19.8,41.947Z",
    transform: "translate(-8.133 -15.986)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11300",
    "data-name": "Path 11300",
    d: "M15.227,32.735a.574.574,0,0,1-.41-.981l1.327-1.327a.577.577,0,1,1,.813.819l-1.321,1.321A.577.577,0,0,1,15.227,32.735Z",
    transform: "translate(-6.198 -12.802)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11301",
    "data-name": "Path 11301",
    d: "M17.5,37.337a.574.574,0,0,1-.41-.981l2.187-2.181a.579.579,0,1,1,.819.819L17.918,37.17A.577.577,0,0,1,17.5,37.337Z",
    transform: "translate(-7.158 -14.387)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11302",
    "data-name": "Path 11302",
    d: "M24.406,33.665H4.214A1.154,1.154,0,0,1,3.06,32.512V15.2A1.154,1.154,0,0,1,4.214,14.05h8.5a.577.577,0,0,1,0,1.154h-8.5V32.512H24.406V24.054a.577.577,0,0,1,1.154,0v8.458A1.154,1.154,0,0,1,24.406,33.665Z",
    transform: "translate(-1.295 -5.944)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3776",
    "data-name": "Rectangle 3776",
    width: 5.123,
    height: 1.154,
    transform: "translate(3.496 11.567)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3777",
    "data-name": "Rectangle 3777",
    width: 1.154,
    height: 1.154,
    transform: "translate(4.073 9.837)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3778",
    "data-name": "Rectangle 3778",
    width: 1.154,
    height: 1.154,
    transform: "translate(5.804 9.837)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3779",
    "data-name": "Rectangle 3779",
    width: 30,
    height: 30,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLabelActive);
export default __webpack_public_path__ + "static/media/whiteLabel_active.85002e5d3072dfbbaa73afda0cb7f300.svg";
export { ForwardRef as ReactComponent };